




    import {Vue, Component, Emit, Watch, Prop} from 'vue-property-decorator'
    import dataProxy from '@/services/data-proxy.service';

@Component({})
export default class PrijaveKvarovaEditor extends Vue {
    @Prop() value!: string;
    @Prop() vozilo!: number;
    prijaveKvara = [];

    model = '';

    async created() {
        this.vratiPrijaveKvara(null);
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Watch('vozilo') async onVoziloChanged(id: number) {
        this.vratiPrijaveKvara(id);
    }

    @Emit() input(val) {

    }

    private async vratiPrijaveKvara(vozilo?: number) {
        if (vozilo) {
            const prijave = await dataProxy.vratiPrijaveKvaraZaVozilo(vozilo);
            const pk = prijave.map(x => ({id: x.id.toString(), text: x.broj}));
            pk.unshift({id: '', text: '...'});
            this.prijaveKvara = pk;
        }
    }
}
